import React from 'react';
import { styled } from 'linaria/react';
import { cx } from 'linaria';
import Image from '@jetshop/ui/Image/Image';
import ReadMore from '../Util/ReadMore';
import { SubCategories } from './SubCategories';
import { BreadcrumbsWrapper } from '../Layout/BreadcrumbsWrapper';
import { theme } from '../Theming/Theming';
import {
  ContentRender,
  convertPropsToObject,
} from '../ContentRender/ContentRender';
import TextContent from '../ui/TextContent';
import { config } from '../../shop.config.custom';
import { SubCategoriesGrid } from './SubCategoriesGrid';
import BackArrow from '../ui/BackArrow';
import MaxWidth from '../Layout/MaxWidth';

const Wrapper = styled('div')`
  .slider-box-wrapper.no-scroll {
    .slider-items {
      justify-content: center;
    }
  }
`;

const CategoryHeaderWrapper = styled('div')`
  .category-image-wrapper {
    ${theme.below.md} {
      [data-flight-image-container] {
        padding-bottom: 25% !important;
      }
    }
  }
  > header {
    padding: 0 ${theme.general.pagePadding.lg};
    max-width: ${theme.general.maxWidthText};
    > h1 {
      position: relative;
      display: flex;
      align-items: center;
      font-family: ${theme.font.secondary};
      font-weight: ${theme.weights.normal};
      text-transform: none;
    }
    .category-description {
    }
    margin: 0 auto;
    text-align: center;
    > h1 {
      justify-content: center;
    }
    .breadcrumbs-wrapper {
      > ul {
        justify-content: center;
      }
    }
    .slider-box-wrapper.no-scroll {
      .slider-items {
        justify-content: center;
      }
    }
  }
`;

const StyledContentRender = styled(ContentRender)`
  margin-bottom: 1%;
`;

const CategoryHeader = ({
  category,
  breadcrumbProps = false,
  standardCategory = true,
  showSubs = true,
}) => {
  const imageData = category?.data?.items?.filter(
    (item) => item.type === 'category-image'
  )[0];
  const categoryImage = imageData && convertPropsToObject(imageData);
  const showGrid = config.routes.brand.id === category.id;
  const brandArea = config.routes.brand.id === category.parentId;
  return (
    <Wrapper
      className={cx(
        standardCategory && 'standard',
        categoryImage && 'has-image'
      )}
    >
      <CategoryHeaderWrapper
        className={cx(
          standardCategory && 'standard',
          categoryImage && 'has-image'
        )}
      >
        {categoryImage && (
          <div className={`category-image-wrapper`}>
            <Image
              critical={true}
              aspect={'30:8'}
              crop={!brandArea}
              src={categoryImage.imageUrl}
              alt={categoryImage.imageAlt}
              sizes={[1]}
              cover={!brandArea}
              quality={80}
            />
          </div>
        )}
        <header
          className={`category-header-wrapper ${
            standardCategory ? 'standard' : ''
          }`}
        >
          {breadcrumbProps && <BreadcrumbsWrapper {...breadcrumbProps} />}
          <h1 data-testid="page-header" className="category-name">
            <BackArrow parents={breadcrumbProps.parents} />
            {category.name}
          </h1>
          {category.content && (
            <div
              className={`category-description content-area ${
                standardCategory ? 'standard' : ''
              }`}
              data-testid="category-description"
            >
              {standardCategory ? (
                <ReadMore breakPoint={150} maxHeight={100} icon={true}>
                  <TextContent content={category.content} />
                </ReadMore>
              ) : (
                <TextContent content={category.content} />
              )}
            </div>
          )}
          {showGrid && <SubCategoriesGrid category={category} />}
        </header>
      </CategoryHeaderWrapper>
      {!showGrid && showSubs && (
        <MaxWidth>
          <SubCategories
            category={category}
            parents={breadcrumbProps.parents}
            noSiblings={brandArea}
          />
        </MaxWidth>
      )}
      <StyledContentRender data={category.data} />
    </Wrapper>
  );
};

export default CategoryHeader;
